import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType, HttpHeaders } from '@angular/common/http';
import { AgendaMasivaModel } from '../models/agendaMasiva.model';
import { Observable } from 'rxjs';
import { AppSettings } from '../app.settings';
import { ConstantesService } from './services/constantes.service';
import { UrlService } from './services/url.service';
import { GlobalService } from './global.service';

@Injectable({
  providedIn: 'root'
})
export class UploadService {


  constructor(private httpClient: HttpClient,
    private urlService: UrlService,
    private globalService: GlobalService) {

  }

  public getHeaders(): HttpHeaders {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');

    return headers;
  }

  private cargaSessionContext() {
    const obj = {};
    obj[ConstantesService.USER_ID_HEADER] = sessionStorage.getItem(ConstantesService.USER_ID_HEADER);
    obj[ConstantesService.TOKEN_EXP_DATE_HEADER] = sessionStorage.getItem(ConstantesService.TOKEN_EXP_DATE_HEADER);
    // obj[ConstantesService.LANGUAGE_HEADER] = sessionStorage.getItem(ConstantesService.LANGUAGE_HEADER);
    obj[ConstantesService.TIPO_DOC_SESSSION] = sessionStorage.getItem(ConstantesService.TIPO_DOC_SESSSION);
    obj[ConstantesService.NUMBER_HEADER] = sessionStorage.getItem(ConstantesService.NUM_DOC_SESSSION);
    return obj;
  }

  public cargarArchivo(uriService: string, documento: any): Observable<any[]> {

    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/octet-stream');
    headers.append('Content-Disposition', 'attachment');
    headers = headers.append(ConstantesService.SESSION_CONTEXT, JSON.stringify(this.cargaSessionContext()));
    headers = this.globalService.cargarInformacionSDK(headers);

    return this.httpClient.post<any[]>(`${this.urlService.hostAPI_ACCVIS}${uriService}`, documento, { headers });
  }

  public cargarArchivoUAC(uriService: string, documento: any): Observable<any[]> {

    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/octet-stream');
    headers.append('Content-Disposition', 'attachment');
    headers = headers.append(ConstantesService.SESSION_CONTEXT, JSON.stringify(this.cargaSessionContext()));
    headers = this.globalService.cargarInformacionSDK(headers);

    return this.httpClient.post<any[]>(`${this.urlService.hostAPI_UAC}${uriService}`, documento, { headers });
  }
  
    public cargarArchivoSB(uriService: string, documento: any): Observable<any[]> {

    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/octet-stream');
    headers.append('Content-Disposition', 'attachment');
    headers = headers.append(ConstantesService.SESSION_CONTEXT, JSON.stringify(this.cargaSessionContext()));
    headers = this.globalService.cargarInformacionSDK(headers);

    return this.httpClient.post<any[]>(`${this.urlService.hostAPI_CARGUE_MASIVO}${uriService}`, documento, { headers });
  }
  
   public cargarArchivoSBAsync(uriService: string, documento: any): Observable<any> {

    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/octet-stream');
    headers.append('Content-Disposition', 'attachment');
    headers = headers.append(ConstantesService.SESSION_CONTEXT, JSON.stringify(this.cargaSessionContext()));
    headers = this.globalService.cargarInformacionSDK(headers);

    return this.httpClient.post<any>(`${this.urlService.hostAPI_CARGUE_MASIVO}${uriService}`, documento, { headers });
  }

  public cargarArchivoFotoARL(uriService: string, documento: any): Observable<any[]> {

    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/octet-stream');
    headers.append('Content-Disposition', 'attachment');
    headers = headers.append(ConstantesService.SESSION_CONTEXT, JSON.stringify(this.cargaSessionContext()));
    return this.httpClient.post<any[]>(`${this.urlService.hostAPI_FUNCIONARIOS}${uriService}`, documento, { headers });
  }

  public registrarAgendaMasiva(uriService: string, lista: AgendaMasivaModel[]): Observable<any> {
    let headers = this.getHeaders();
    headers = headers.append(ConstantesService.SESSION_CONTEXT, JSON.stringify(this.cargaSessionContext()));
    headers = this.globalService.cargarInformacionSDK(headers);
    return this.httpClient.post(`${this.urlService.hostAPI_ACCVIS}${uriService}`, lista, { headers });
  }
}
